<template>
<div class="app-container">
  <div class="box-card">
    <div class="box-card-head">
      <dynamic-form
        labelWidth="110px"
        :formConfig="formConfig"
        v-model="form"
        :showBtn="false"
        @getProjectId="handleProjectId"
      />
    </div>
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      title="新增任务"
      :enableDrag="true"
      width="600px"
      @close="cancel"
    >
      <dynamic-form
        :formConfig="contentConfig"
        v-model="content"
        @submit="submit"
        @cancelForm="cancel"
        ref="pageForm"
      />
    </drag-dialog>
    <edit-data-table2
      :showNumber="false"
      :editable="true"
      :head="tableHead"
      :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
      :border="true"
      :data.sync="tableData"
      :toolBar="{hidden: true}"
      ref="delRew"
    >
      <template v-for="(value, key) in daysMap" v-slot:[key]="scope">
        <edit-data-table2
          :key="key"
          :showNumber="false"
          :editable="true"
          :showHeader="false"
          :head="innerTableHead"
          :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
          :border="false"
          :data.sync="tableData[scope.$index][key]"
          :showAdd="getShow(value, tableData[scope.$index])"
          height=""
          :toolBar="{label: '操作', hidden: false, width: 80, minWidth: '', align: 'center', fixed: false}"
          @addFlag="addFlag(key, scope.$index, tableData[scope.$index].taskReceiverPerson, value)"
        >
          <template #toolbar="{row, $index}">
            <el-button type="text" size="mini" icon="el-icon-edit" @click="editRow(row, scope.$index, key, value)"/>
            <el-popover :ref="`popover-${row.id}`" placement="top" width="180">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[`popover-${row.id}`][0].doClose()">取消</el-button>
                <el-button
                  :loading="delLoading"
                  type="primary"
                  size="mini"
                  @click="subDelete(row.id, $index, scope.$index, key)">确定
                </el-button>
              </div>
              <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
            </el-popover>
          </template>
        </edit-data-table2>
      </template>
    </edit-data-table2>
  </div>
</div>
</template>

<script>
  import './components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import "@/components/dynamic-form"
  import { parseTime} from "@/utils"
  import DragDialog from "@/components/DragDialog"
  import "@/components/dynamic-form"
  import { findList, save, update, getDisposablePerson, delTask } from '@/api/bill/assignment'

  export default {
    name: "Assignment",
    mixins: [DataTableMixin],
    components: { DragDialog },
    data() {
      return {
        daysMap: {},
        delLoading: false,
        content: {},
        contentConfig: {
          formItemList: [
            {
              label: '节点描述',
              key: 'projectNode',
              type: 'databox',
              span: 24,
              props: {
                label: 'taskNodeDescription',
                value: 'personId'
              },
              tableColumn: [
                { property: "nodecode", label: "节点编号", query: { type: 'input' } },
                { property: "taskNodeDescription", label: "节点描述", query: { type: 'input' } },
                ],
              extendParms: {queryFieldItem: 'id,number,taskNodeDescription'},
              disabled: true,
              multiple: false,
              rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
            },
            {
              span: 24,
              type: "input",
              key: "taskContent",
              label: "任务内容",
              subtype: 'textarea',
              placeholder: "请输入任务内容",
               rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
            },
            {
              span: 24,
              label: '计划完成日期',
              key: 'plannedEndTime',
              type: 'date',
               rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
            },
            {
              span: 24,
              label: '可支配人天',
              key: 'disposableHumanNature',
              type: 'input',
              subtype: 'number',
               rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
            },
          ],
          changeFlag: false,
        },
        changeContentList: [],
        dialogVisible: false,
        formConfig: {
          formItemList: [
            {
              type: "databox",
              key: "projectId",
              label: "项目号",
              placeholder: "请选择项目",
              value: "",
              span: 6,
              props: {
                label: "code",
                value: ""
              },
              url: "/bizTaskDecomposition/findProject",
              tableColumn: [
                {
                  property: "code",
                  label: "项目号",
                  query: {
                    type: "input"
                  }
                },
                {
                  property: "name",
                  label: "项目名称",
                  query: {
                    type: "input"
                  }
                }
              ],
              extendParms: { queryFieldItem: "id,number,name" },
              multiple: false
            },
            {
              span: 6,
              label: '选择周',
              key: 'time',
              type: 'date',
              subtype: 'week',
              viewFormat: "yyyy 第 WW 周",
            },
          ]
        },
        form: {},
        innerTableHead: [
          { label: '任务编号', prop: 'taskNodeCode', width: 69 },
          { label: '任务内容', prop: 'taskContent', width: 380 },
        ],
        tableHead: [
          {
            label: '可支配人员\\日期',
            prop: 'taskReceiverPerson.name',
            width: 120,
          },
          {
            label: '周一',
            prop: 'monday',
            width: 550,
          },
          {
            label: '周二',
            prop: 'tuesday',
            width: 550,
          },
          {
            label: '周三',
            prop: 'wendnesday',
            width: 550,
          },
          {
            label: '周四',
            prop: 'thursday',
            width: 550,
          },
          {
            label: '周五',
            prop: 'friday',
            width: 550,
          },
          {
            label: '周六',
            prop: 'saturday',
            width: 550,
          },
          {
            label: '周日',
            prop: 'sunday',
            width: 550,
          },
        ],
        tableData: [],
        projectCode: '',
        isAdd: true, // 是否显示新增按钮
        projectName: '',
      }
    },
    created() {
      this.initTime()
    },
    watch: {
      'form.time': {
        handler(newTime, oldTime) {
          if (parseTime(newTime, '{y}-{m}-{d}') !== parseTime(oldTime, '{y}-{m}-{d}')) {
            this.setLabelTime()
          }
        }
      },
      'content.projectNode': {
        handler(newVal, oldVal) {
          if (newVal.id && !this.content.taskContent) {
            if (!oldVal || newVal.id !== oldVal.id) {
              this.content.taskContent = newVal.name + '-'
            }
          }
        },
        deep: true,
      },
      'form.projectId': {
        handler(val,oldVal) {
           if (val && val !== oldVal) {
             this.projectName = val.name
           }
        },
        deep: true
      }
    },
    methods: {
      // 新增按钮是否显示
      getShow(time,val) {
        const personnelDays = val.personnelDay.map(item => { return item.occupyDate })
        return personnelDays.includes(time)
      },
      editRow(row, index, key, time) {
        console.log("bizTaskDecomposition/findProjectNode 接口1")
        this.contentConfig.formItemList.find((item, theIndex) => {
          if (item.key === 'projectNode') {
            this.contentConfig.formItemList[theIndex].url = `/bizTaskDecomposition/findProjectNode/${this.projectCode}/${parseTime(time, '{y}-{m}-{d}')}`
            this.contentConfig.formItemList[theIndex].disabled = false
            this.contentConfig.changeFlag = !this.contentConfig.changeFlag
          }
        })
        this.content = { ...row, plannedStartTime: time }
        this.changeContentList = this.tableData[index][key]
        this.dialogVisible = true
      },
      subDelete(id, index, tableIndex, key) {
        delTask(id).then(res => {
          if (res.code === 200) {
            this.tableData[tableIndex][key].splice(index, 1)
            this.$message.success('删除成功')
          }
        })
      },
      getDate(code) {
        getDisposablePerson({ projectCode: code, startTime: parseTime(this.daysMap.monday, '{y}-{m}-{d}'), endTime: parseTime(this.daysMap.sunday, '{y}-{m}-{d}') }).then(res => {
          if (res.code === 200) {
            const resultTable = res.data.map(item => { return { taskReceiverPerson: { name: item.name, id: item.personId, startTime: new Date(item.startTime).getTime(), endTime: new Date(item.endTime).getTime() }, monday: [], tuesday: [], wendnesday: [], thursday: [], friday: [], saturday: [], sunday: [],personnelDay: item.personnelDay} })
            findList({ projectCode: code, startTime: parseTime(this.daysMap.monday, '{y}-{m}-{d}'), endTime: parseTime(this.daysMap.sunday, '{y}-{m}-{d}') }).then(res => {
              if (res.code === 200) {
                res.data.forEach(item => {
                  resultTable.find((dataItem, index) => {
                    if (item.taskReceiver === dataItem.taskReceiverPerson.id) {
                      for (const key in this.daysMap) {
                        if (item.plannedStartTime.slice(0, 10) === parseTime(this.daysMap[key], '{y}-{m}-{d}')) {
                          item.projectNode = item.bsProjectNode
                          item.projectNode.taskNodeDescription = item.taskNodeDescription
                          delete item.bsProjectNode
                          resultTable[index][key].push(item)
                          break
                        }
                      }
                      return true
                    }
                  })
                })
              }
              this.tableData = resultTable
            }).catch(() => {
              this.tableData = resultTable
            })
          }
        }).catch(() => {
          this.tableData = []
        })
      },
      handleProjectId(data) {
        this.projectCode = data
        this.getDate(this.projectCode)
      },
      submit() {
        this.content.projectCode = this.form.projectId.code
        this.content.nodecode = this.content.projectNode.nodecode
        console.log(this.content)
        const submitData = { ...this.content, projectNode: this.content.projectNode.id, plannedEndTime: new Date(this.content.plannedEndTime).getTime() }
        if (submitData.plannedStartTime  > submitData.plannedEndTime  + 24 * 60 * 60 * 1000 - 1) {
          this.$message.warning('计划完成时间不能小于计划开始时间！')
          return false
        }
        submitData.plannedStartTime = new Date(submitData.plannedStartTime).getTime();
        console.log('sub....',submitData)
        // else if (submitData.plannedEndTime > submitData.endTime) {
        //   this.$message.warning(`计划结束时间不能大于该名员工结束占用时间(${parseTime(submitData.endTime, '{y}-{m}-{d}')})!`)
        //   return false
        // } else if (submitData.plannedStartTime < submitData.startTime) {
        //   this.$message.warning(`计划开始时间不能小于该名员工占用开始时间(${parseTime(submitData.startTime, '{y}-{m}-{d}')})!`)
        //   return false
        // } else {
          delete submitData.startTime
          delete submitData.endTime
          if (this.content.id) {
            update(submitData).then(res => {
              if (res.code === 200) {
                this.changeContentList.find((item, index) => {
                  if (item.id === this.content.id) {
                    this.changeContentList.splice(index, 1, this.content)
                    this.$message.success('修改成功')
                    this.dialogVisible = false
                    return true
                  }
                })
                this.dialogVisible = false
              }
            })
          } else {
            save(submitData).then(res => {
              if (res.code === 200) {
                this.content.id = res.data.id
                this.content.taskNodeCode = res.data.taskNodeCode
                this.changeContentList.push(this.content)
                this.$message.success('保存成功')
                this.dialogVisible = false
              }
            })
          }
      },
      cancel() {
        this.dialogVisible = false
      },
      addFlag(key, index, taskReceiverPerson, time) {
        console.log("新增数据 bizTaskDecomposition/findProjectNode")
       console.log(taskReceiverPerson)
        this.contentConfig.formItemList.find((item, theIndex) => {
          if (item.key === 'projectNode') {
            this.contentConfig.formItemList[theIndex].url = `/bizTaskDecomposition/findProjectNode/${this.projectCode}/${parseTime(time, '{y}-{m}-{d}')}`
            this.contentConfig.formItemList[theIndex].disabled = false
            this.contentConfig.changeFlag = !this.contentConfig.changeFlag
          }
        })
        this.content = { taskReceiver: taskReceiverPerson.id, plannedStartTime: new Date(time).getTime(), startTime: taskReceiverPerson.startTime, endTime: taskReceiverPerson.endTime}
        this.changeContentList = this.tableData[index][key]
        this.dialogVisible = true
      },
      initTime() {
        this.form.time = new Date()
      },
      setLabelTime() {
        const selectTime = this.form.time
        let day = selectTime.getDay()
        day = day === 0 ? 7 : day
        const days = ['monday', 'tuesday', 'wendnesday', 'thursday', 'friday', 'saturday', 'sunday']
        for (let i = 1; i <= 7; i++) {
          const theTime = selectTime.getTime() + (i - day) * 24 * 60 * 60 * 1000
          this.daysMap[days[i - 1]] = parseTime(theTime,'{y}-{m}-{d}')
          const labelTime = parseTime(theTime, '{y}-{m}-{d}')
          this.tableHead[i].label = `${this.tableHead[i].label.slice(0, 2)}(${labelTime})`
        }
        if (this.projectCode.length) {
          this.getDate(this.projectCode)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    .box-card-head {
      /deep/ .el-form-item__label {
        width: 60px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 60px !important;
      }
      /deep/ .el-col {
        padding-left: 0 !important;
      }
    }
    /deep/.el-table .cell.el-tooltip {
      white-space: pre-line;
    }
  }
}
</style>
